<template>
<!--    <div v-if="filterCount > 0" class="flex-row gap-sm">-->
<!--      <dd-filter-pill @click="resetByKey('automationName')" v-if="automationName">-->
<!--        Automations met naam:  "{{ automationName }}"-->
<!--      </dd-filter-pill>-->
<!--      <dd-filter-pill @click="resetByKey('searchModelType')" v-if="filterNotEmpty(searchModelType)">-->
<!--        Automations die zoeken op: {{ searchModelTypeLabel(searchModelType) }}-->
<!--      </dd-filter-pill>-->
<!--      <dd-filter-pill @click="resetByKey('actionType')" v-if="filterNotEmpty(actionType)">-->
<!--        Automations met actie: {{ actionTypeLabel(actionType) }}-->
<!--      </dd-filter-pill>-->
<!--      <dd-filter-pill @click="resetByKey('actionType')" v-if="filterNotEmpty(customers)">-->
<!--        Automations met resultaten voor klanten-->
<!--      </dd-filter-pill>-->
<!--      <dd-filter-pill @click="resetByKey('inactiveAutomations')" v-if="!inactiveAutomations">-->
<!--        Geen inactieve-->
<!--      </dd-filter-pill>-->
<!--      <dd-filter-pill @click="resetByKey('activeAutomations')" v-if="!activeAutomations">-->
<!--        Geen actieve-->
<!--      </dd-filter-pill>-->
<!--    </div>-->
    <div class="flex-col gap-y-md">
      <div @click="(e) => e.stopPropagation()" class="flex-col gap-md">
        <div class="flex-row gap-sm">
          <dd-switch
              v-model="activeAutomations"
              :value-as-int="true"
              title="Actieve"
          />
          <dd-switch
              v-model="activeAutomations"
              :value-as-int="true"
              title="Eenmalige"
          />
          <dd-switch
              v-model="inactiveAutomations"
              :value-as-int="true"
              title="Inactieve"
          />
        </div>
        <dd-select
            v-model="searchModelType"
            :options="searchableOptions"
            mode="multiple"
            title="Type object in selectie"
        >

        </dd-select>
        <dd-select
            v-model="actionType"
            mode="multiple"
            :options="actionTypeOptions"
            title="Type actie"
        >
        </dd-select>
        <dd-customer-select
            title="Automations met resultaten voor klanten"
            :multiple="true"
            v-model="customers"
        >

        </dd-customer-select>
        <dd-input
            v-model="automationName"
            title="Zoek op automation titel">

        </dd-input>
      </div>
      <div class="flex-row gap-sm justify-content-end align-items-center">
        <dd-button @click="resetAll" :outlien="true" type="danger" :small="true">
          Reset
        </dd-button>
        <dd-button  @click="onFilterInput" type="primary" :small="true">
          Opslaan
        </dd-button>
      </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import _ from "lodash";
import automationApi from "~/api/automation";

export default {
  name: "FilterComponent",
  data() {
    return {
      searchableOptions: [],
      actionTypeOptions: [
        {
          value: 'send_email',
          label: 'Verstuurt e-mail',
        },
        {
          value: 'create_task',
          label: 'Maakt taak aan',
        },
        {
          value: 'create_signal',
          label: 'Maakt signaal aan',
        },
      ],
    }
  },
  created() {
    this.getMainSearchableOptions();
  },
  computed: {
    ...mapFields('$_automation', [
      'filter.searchModelType',
      'filter.actionType',
      'filter.automationName',
      'filter.activeAutomations',
      'filter.onceAutomations',
      'filter.inactiveAutomations',
      'filter.customers',
    ]),
    ...mapState('$_automation', {
      filterLoaded: state => state.filterLoaded,
      filter: state => state.filter,
      defaultFilter: state => state.defaultFilter,
    }),
    filterCount() {
      let count = 0;
      Object.keys(this.filter).forEach(key => {
        if((Array.isArray(this.filter[key]))) {
          if (this.filter[key].length === 0) return;
          count++;
          return;
        }
        if(this.filter[key] !== this.defaultFilter[key]) return count++;
      });
      return count;
    },
  },
  methods: {
    ...mapMutations('$_automation', {
      setFilter: 'SET_FILTER',
      setFilterLoaded: 'SET_FILTER_LOADED',
      setInactiveAutomationables: 'SET_INACTIVE_AUTOMATIONABLES',
      setActiveAutomationables: 'SET_ACTIVE_AUTOMATIONABLES',
    }),
    ...mapActions('$_automation', {
      fetchAutomationables: 'fetchAutomationables',
      saveFilterToUserStore: 'saveFilter',
      getFilter: 'getFilter',
    }),
    getMainSearchableOptions() {
      automationApi.getMainSearchableOptions().then((response) => {
        this.searchableOptions = response;
      });
    },
    filterNotEmpty(filter = null) {
      return (Array.isArray(filter) && filter?.length > 0);
    },
    resetByKey(key) {
      if(!(key in this.filter) || (this.filter[key] === this.defaultFilter[key])) return;
      this.setFilter({
        ...this.filter,
        [key]: this.defaultFilter[key],
      })
      this.onFilterInput();
    },
    resetAll() {
      this.setFilter(this.defaultFilter);
      this.onFilterInput();
    },
    onFilterInput: _.debounce(function() {this.reloadAutomationsWithFilter()}, 500),
    actionTypeLabel(value) {
      return value?.map((actionType) => this.actionTypeOptions?.find(option => option.value === actionType)?.label)?.join(', ');
    },
    searchModelTypeLabel(value) {
      return value.map(className => this.searchableOptions?.find(option => option.value === className)?.label).join(', ');
    },
    reloadAutomationsWithFilter() {
      if(!this.filter?.inactiveAutomations) {
        this.setInactiveAutomationables([]);
      }
      if(!this.filter?.activeAutomations) {
        this.setInactiveAutomationables([]);
      }
      return this.fetchAutomationables(true).then(() => {
        this.saveFilterToUserStore();
      });
    }
  },
};
</script>

<style scoped>

</style>
